export default __webpack_public_path__ + "static/media/icon_GA.f5e7b474.png";